import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; 
import "./BrandsPage.css";
import { Container } from "react-bootstrap";

const BrandsPage = ({ url, data }) => {
  const [brandsData, setBrandsData] = useState([]);
  const navigate = useNavigate(); 

  useEffect(() => {
    if (data?.content?.objects && Array.isArray(data?.content?.objects)) {
      setBrandsData(data?.content?.objects);
    }
  }, [data]);

  function extractTextFromHTML(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  const handleBrandClick = (brand) => {
    navigate(`/products?brand=${encodeURIComponent(brand)}`);
  };

  return (
    <div className="brand-page">
      <Container className="brand-page-container">
        <header className="Header">
          <h2>Filtrix Brands</h2>
          <span>{extractTextFromHTML(data?.page_description)}</span>
        </header>

        <div className="brand-container">
          {brandsData.length > 0 ? (
            brandsData.map((item, index) => (
              <div
                className="brands-image-container"
                key={index}
                onClick={() => handleBrandClick(item.brand)}
              >
                <div className="brands-slider-image">
                  <img
                    className="brands-slider-img"
                    src={`${url}${item.image}`}
                    alt={`Brand-${index}`}
                  />
                </div>
                <div className="brands-name">
                  <span>{item.brand}</span>
                </div>
              </div>
            ))
          ) : (
            <p>No brands available.</p>
          )}
        </div>
      </Container>
    </div>
  );
};

export default BrandsPage;
